import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { timer, of } from "rxjs";
import { tap, switchMap, filter, publishReplay, refCount } from "rxjs/operators";
import format from "tz-format";

import { FilterPageOptionEnum } from "../shared/enums";
import { ApplicationState, CallEvent } from "../shared/types";
import { CallEventsActions, TimerModel, PermissionsService, FeatureService } from "../shared/index";
import { FilterModel } from "../filter/filter.model";

const FIVE_MINUTES = 1000 * 60 * 5;

@Injectable()
export class CallEventModel extends TimerModel {
	private readonly store = inject<Store<ApplicationState>>(Store);
	private readonly permissionsService = inject(PermissionsService);
	private readonly featureService = inject(FeatureService);
	private readonly filterModel = inject(FilterModel);

	// @ts-expect-error TS7006
	closeCallEvent(result, callEvent: CallEvent) {
		const data = {
			callReason: result.reason.id,
			patient: {
				id: result.resident.id,
				name: result.resident.name,
				firstName: result.resident.firstName,
			},
			notes: result.remark,
			closeDate: format(),
		};

		if (data.notes === "") {
			delete data.notes;
		}

		if (data.patient.id === undefined) {
			// @ts-expect-error TS2790
			delete data.patient;
		}

		const { callId } = callEvent;

		const closedCallEvent = {
			...callEvent,
			callReason: result.reason.id,
		};

		this.performAsyncAction(CallEventsActions.close(callId, data))
			.pipe(
				tap(() => {
					this.store.dispatch(CallEventsActions.close(callId, closedCallEvent));
				}),
			)
			.subscribe();
	}

	loadCallEvents() {
		const obs$ = this.performAsyncAction(CallEventsActions.get()).pipe(publishReplay(1), refCount());

		obs$.subscribe({
			next: (result) => {
				if (result && result.payload && Array.isArray(result.payload.calls)) {
					this.store.dispatch(CallEventsActions.set(result.payload.calls));
				}
			},
			error: (err) => {
				console.log(err);
			},
		});

		return obs$;
	}

	start() {
		return of(
			this.featureService.hasFeatures(["CallAlarms"]) && this.permissionsService.userHasPermissions(["MEDAPP.CARE"]),
		)
			.pipe(
				filter(Boolean),
				switchMap(() => timer(FIVE_MINUTES, FIVE_MINUTES)),
				tap(() => this.loadCallEvents()),
			)
			.subscribe();
	}

	selectFilter(filterId: FilterPageOptionEnum) {
		this.filterModel.selectFilter(filterId);
	}
}
